module.exports = __webpack_public_path__ + "img/GH-kyujin-top-illustration009.b89d23e3.webp";